import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Carrito`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos/`, {
    meta: {
      toastMessage: 'Ocurrió un error al buscar los carritos.',
      tipoError: 'carrito'
    }
  })
}

export function buscarPorId(idCarrito) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idCarrito}`, {
    meta: {
      toastMessage: 'Ocurrió un error al buscar el carrito.',
      tipoError: 'carrito'
    }
  })
}

export function buscarPorUsuario(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarPorUsuario/${idUsuario}`, {
    meta: {
      toastMessage: 'Ocurrió un error al buscar el carrito.',
      tipoError: 'carrito'
    }
  })
}

export function insertar(carrito) {
  return http.post(`${API_ENDPOINT}/InsertarItem/`, carrito)
}
export function actualizar(carrito) {
  return http.put(API_ENDPOINT, carrito)
}

export function eliminar(carrito) {
  return http.post(`${API_ENDPOINT}/EliminarItem/`, carrito)
}

export function eliminarCarrito(carrito) {
  return http.post(`${API_ENDPOINT}/EliminarCarrito/`, carrito)
}

export function crearPedido(carrito) {
  return http.post(`${API_ENDPOINT}/CrearPedido/`, carrito)
}
